// extracted by mini-css-extract-plugin
module.exports = {"add-button":"Step2Inventory_add-button_28tTo"};